import { createRequestActions } from 'actions';
import * as types from 'constants/ActionTypes.js';
import { ROOT_URL } from 'constants/Config.js';

import axios from 'axios';

export function createInaccuracyReport(data) {
  const { id, message } = data;
  return (dispatch) => {
    dispatch({ type: types.CREATE_INACCURACY_REPORT, meta: { loader: true } });
    return axios
      .post(`${ROOT_URL}/buildings/inaccuracy/create`, { message, id })
      .then((response) => {
        dispatch({ type: types.CREATE_INACCURACY_REPORT_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        console.error(error);
        dispatch({ type: types.CREATE_INACCURACY_REPORT_ERROR, payload: error });
      });
  };
}

export function getCities() {
  return (dispatch) => {
    try {
      return axios.get(`${ROOT_URL}/cities`).then(({ data: { data } }) => {
        dispatch({ type: types.SET_CITIES, payload: data });
        return data;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: types.SET_CITIES, payload: [] });
    }
  };
}

const prepareDataBuilding = (data) => {
  const buildingData = data.data;

  if (buildingData.builders !== undefined && buildingData.builders.name) {
    buildingData.builder = [
      {
        id: buildingData.builders.id,
        name: buildingData.builders.name,
      },
    ];
  }

  const users = [];

  if (Array.isArray(buildingData.sales_offices)) {
    buildingData.sales_offices.forEach((office, officeIndex) => {
      if (Array.isArray(office.users) && office.users.length) {
        office.users.forEach((user, userIndex) => {
          if (user.phone && user.first_name) {
            users.push({
              email: user.email,
              email2: '',
              name: [user.first_name, user.last_name].filter((item) => item).join(' '),
              phone: user.phone,
              phone2: '',
              position: user.position,
              id: `${officeIndex}-${userIndex}`,
            });
          }
        });
      }
    });
  }

  if (users.length) {
    buildingData.contacts = users;
  }

  return data;
};

export function loadBuilding(id) {
  return (dispatch) => {
    dispatch({ type: types.LOAD_BUILDING_START, payload: { id }, meta: { loader: true } });
    const userUid = localStorage.getItem('public');
    return axios
      .get(`${ROOT_URL}/buildings/get?id=${id}&userUid=${userUid}`)
      .then((response) => {
        dispatch({
          type: types.LOAD_BUILDING_SUCCESS,
          payload: prepareDataBuilding(response.data),
          meta: { loader: true },
        });
        return response;
      })
      .catch((error) => {
        dispatch({ type: types.LOAD_BUILDING_ERROR, payload: error, meta: { loader: true } });
      });
  };
}

export function loadDocuments(id) {
  return (dispatch) => {
    dispatch({ type: types.LOAD_DOCUMENTS_START, meta: { loader: true } });
    return axios
      .get(`${ROOT_URL}/buildings/docs/list?id=${id}`)
      .then((response) => {
        dispatch({
          type: types.LOAD_DOCUMENTS_SUCCESS,
          payload: response.data,
          meta: { loader: true },
        });
      })
      .catch((error) => {
        dispatch({ type: types.LOAD_DOCUMENTS_ERROR, payload: error, meta: { loader: true } });
      });
  };
}

export function loadNews(id) {
  return (dispatch) => {
    dispatch({ type: types.LOAD_NEWS_START, meta: { loader: true } });
    const userUid = localStorage.getItem('public');
    return axios
      .get(`${ROOT_URL}/buildings/news?id=${id}&userUid=${userUid}`)
      .then((response) => {
        dispatch({ type: types.LOAD_NEWS_SUCCESS, payload: response.data, meta: { loader: true } });
      })
      .catch((error) => {
        dispatch({ type: types.LOAD_NEWS_ERROR, payload: error, meta: { loader: true } });
      });
  };
}

export function loadPavilions(id) {
  return (dispatch) => {
    dispatch({ type: types.LOAD_PAVILIONS_START, meta: { loader: true } });
    return axios
      .get(`${ROOT_URL}/buildings/pavilion/list?id=${id}`)
      .then((response) => {
        dispatch({
          type: types.LOAD_PAVILIONS_SUCCESS,
          payload: response.data,
          meta: { loader: true },
        });
      })
      .catch((error) => {
        dispatch({ type: types.LOAD_PAVILIONS_ERROR, payload: error, meta: { loader: true } });
      });
  };
}

export function loadChess(params) {
  return (dispatch) => {
    dispatch({ type: types.LOAD_CHESS_START, meta: { loader: true } });
    return axios
      .get(`${ROOT_URL}/section/chess`, { params })
      .then((response) => {
        dispatch({
          type: types.LOAD_CHESS_SUCCESS,
          payload: { ...response.data, id: params.id },
          meta: { loader: true },
        });
        return response;
      })
      .catch((error) => {
        dispatch({ type: types.LOAD_CHESS_ERROR, payload: error, meta: { loader: true } });
      });
  };
}

export const searchChess = createRequestActions({
  type: 'SEARCH_CHESS',
  path: ['data'],
  method: 'post',
  url: '/chess/search',
});

export function setCells(id, cells, selected) {
  return (dispatch) => {
    dispatch({ type: types.SET_CHESS_CELLS, payload: { id, cells, selected } });
  };
}

export function setSelected(id, selected) {
  return (dispatch) => {
    dispatch({ type: types.SET_CELL_SELECTED, payload: { id, selected } });
  };
}

export function setFilters(filters) {
  return (dispatch) => {
    dispatch({ type: types.SET_CHESS_FILTERS, payload: filters });
  };
}

export function setZoom(payload) {
  return (dispatch) => {
    dispatch({ type: types.SET_ZOOM, payload });
  };
}

export function setChessTable(selected) {
  return (dispatch) => {
    dispatch({ type: types.SET_CHESS_TABLE, payload: selected });
  };
}

export function setChessExtended() {
  return (dispatch) => {
    dispatch({ type: types.SET_CHESS_EXTENDED });
  };
}

export function setListSort(col) {
  return (dispatch) => {
    dispatch({ type: types.SET_LIST_SORT, payload: col });
  };
}

export function setTableScroll(id, scroll) {
  return (dispatch) => {
    dispatch({ type: types.SET_TABLE_SCROLL, payload: { id, scroll } });
  };
}

export function setPrevLocation(location) {
  return (dispatch) => {
    dispatch({ type: types.SET_PREV_LOCATION, payload: location });
  };
}

export function updateChessState(state) {
  return (dispatch) => {
    dispatch({ type: types.UPDATE_CHESS_STATE, payload: state });
  };
}

export function clickContact(data) {
  const { objectId, userId } = data;
  return (dispatch) => {
    dispatch({ type: types.CREATE_INACCURACY_REPORT, meta: { loader: true } });
    return axios
      .post(`${ROOT_URL}/buildings/contact/click`, { objectId, userId })
      .catch((error) => {
        console.error(error);
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/building.js